import { render, staticRenderFns } from "./StemdoerListSkeleton.vue?vue&type=template&id=46c771d1&scoped=true"
var script = {}
import style0 from "./StemdoerListSkeleton.vue?vue&type=style&index=0&id=46c771d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c771d1",
  null
  
)

export default component.exports